import "./style.css"

function Footer() {
    return (
        <footer className="footer">
            <p className="footer-text">
                Virtual-sayohat © {new Date().getFullYear()}. Barcha huquqlar himoyalangan.
            </p>
            <p className="footer-text">
                <a className="footer-link" href="https://t.me/MirjalolUrozboev">Yordam</a>
            </p>
        </footer>
    )
}

export default Footer
